import React, { useEffect, useState } from 'react';
import { TextField, Button, Grid, Box, CircularProgress, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

import Layout from '../../components/layout';
import { db } from '../../firebaseconf';
import { collection, query, getDocs, addDoc } from "firebase/firestore";
import Header from '../../components/header';
import Alerts from '../../components/alert';

export default function StudentForm() {
    const [loading, setLoading] = useState(false);
    const [alertVisible, setAlertVisible] = useState(false);
    const [newStudent, setNewStudent] = useState({
        name: '', email: '', roll_number: '', father_name: '', class: '', phone: '', admission_number: '', date_of_birth: '', section: '',
    });
    const [semesters] = useState([]);

    // Fetching student data
    useEffect(() => {
        const fetchStudents = async () => {
            const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
            if (!loggedUser || !loggedUser.institution_id) return;
            
            const q = query(collection(db, 'institutions', loggedUser.institution_id, 'students'));
            
            try {
                const snapshot = await getDocs(q);
                const students = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                console.log("Fetched students:", students);
            } catch (error) {
                console.error("Error fetching students:", error);
            }
        };
        
        fetchStudents();
    }, []);

    // Handling form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewStudent(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // Handling student submission (including the current semester)
    const handleAddStudent = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
        if (!loggedUser || !loggedUser.institution_id) return;

        try {
            await addDoc(collection(db, 'institutions', loggedUser.institution_id, 'students'), {
                ...newStudent,
                teacher_id: loggedUser.id,
                institution_id: loggedUser.institution_id,
                created_at: new Date()
            });
            console.log("Student added successfully");
            setNewStudent({
                name: '', email: '', roll_number: '', father_name: '', class: '', phone: '', admission_number: '', date_of_birth: '', section: ''
            });
            setAlertVisible(true);
            setTimeout(() => setAlertVisible(false), 3000);
        } catch (error) {
            console.error("Error adding student:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <Header title="Add Student" />
            <Box component="section" sx={{ p: 5 }}>
                {alertVisible && <Alerts message="Student Added successfully!" type="success" color="success" />}
                {loading && <CircularProgress sx={{ display: 'block', margin: '10px auto' }} />}
                <form onSubmit={handleAddStudent}>

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Student Name"
                                name="name"
                                value={newStudent.name}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Email"
                                name="email"
                                value={newStudent.email}
                                onChange={handleChange}
                                variant="outlined"
                                type="email"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Roll Number"
                                name="roll_number"
                                value={newStudent.roll_number}
                                onChange={handleChange}
                                variant="outlined"
                                type="text"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Admission Number"
                                name="admission_number"
                                value={newStudent.admission_number}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Father's Name"
                                name="father_name"
                                value={newStudent.father_name}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Class"
                                name="class"
                                value={newStudent.class}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Phone No."
                                name="phone"
                                value={newStudent.phone}
                                onChange={handleChange}
                                variant="outlined"
                                type="tel"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Date of Birth"
                                name="date_of_birth"
                                value={newStudent.date_of_birth}
                                onChange={handleChange}
                                variant="outlined"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        {/* Section Selection */}
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel>Current Semester</InputLabel>
                                <Select
                                    value={newStudent.currentsemester}
                                    onChange={handleChange}
                                    name="currentsemester"
                                    label="Current Semester"
                                >
                                    {semesters.map((semester) => (
                                        <MenuItem key={semester} value={semester}>
                                            {semester}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Address */}
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Address"
                                name="address"
                                value={newStudent.address}
                                onChange={handleChange}
                                variant="outlined"
                                multiline
                                rows={4}
                            />
                        </Grid>
                    </Grid>
                    <Box mt={3}>
                        <Button type="submit" variant="contained" color="primary" disabled={loading}>
                            Submit
                        </Button>
                    </Box>
                </form>
            </Box>
        </Layout>
    );
}
